import { Colors, iconNames } from '@zapier/design-system';
export const iconTabsSectionConfig = {
    name: 'IconTabsSection',
    category: 'Zapier Sections',
    image: 'https://cdn.zappy.app/4f358d25a3f6a8c4560b262b80b3dd63.png',
    includeScrollTracking: true,
    inputs: [
        {
            name: 'heading',
            type: 'string',
            defaultValue: 'Flexible plans for teams of all sizes',
        },
        {
            name: 'headingBackgroundColor',
            type: 'string',
            enum: ['', ...Object.keys(Colors)],
            defaultValue: 'moss',
        },
        {
            name: 'headingColor',
            type: 'string',
            enum: ['', ...Object.keys(Colors)],
            defaultValue: 'white',
        },
        {
            name: 'tabs',
            type: 'list',
            broadcast: true,
            required: true,
            subFields: [
                {
                    name: 'text',
                    type: 'string',
                    defaultValue: 'Automation',
                    required: true,
                },
                {
                    name: 'icon',
                    type: 'string',
                    enum: ['', ...Object.keys(iconNames)],
                    required: true,
                },
                {
                    name: 'id',
                    type: 'string',
                },
                {
                    name: 'backgroundColor',
                    type: 'string',
                    enum: ['', ...Object.keys(Colors)],
                    defaultValue: 'sky',
                    required: true,
                },
                {
                    name: 'content',
                    type: 'uiBlocks',
                    defaultValue: [],
                },
            ],
            defaultValue: [
                {
                    text: 'Automation',
                    icon: 'miscCreditCard',
                    backgroundColor: 'sky',
                    content: [],
                },
                {
                    text: 'Interfaces',
                    icon: 'miscCreditCard',
                    backgroundColor: 'sky',
                    content: [],
                },
                {
                    text: 'Tables',
                    icon: 'miscCreditCard',
                    backgroundColor: 'sky',
                    content: [],
                },
            ],
        },
        {
            name: 'changeUrlOnTabChange',
            type: 'boolean',
        },
    ],
};
//# sourceMappingURL=config.js.map